import React, { useEffect, useState } from 'react';
import { Stack, Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
import Header from '../../layout/dashboard/header';
import { InputCustom } from '../../components/UIElements/input-ui';
import TimesheetDetailsContent from '../../components/timesheet/TimesheetDetailsContent';
import {
  TimesheetDetailsProps,
  TimesheetDetailsPropsDummyData,
} from '../../interface/timesheet';
import { getUrlPathId } from '../../utils/url-id';
import { useAuth } from '../../hooks/useAuth';
import { useNotificationService } from '../../components/notification';
import { useMutation } from '@tanstack/react-query';
import { apiGetTimesheetById } from '../../api/timesheet';
import { useLocation } from 'react-router-dom';
import { FlaggingModal } from '../../components/timesheet/TimesheetModal';
import BackButton from '../../components/UIElements/BackButton';

const TimesheetDetails = () => {
  const theme = useTheme();
  const isMedium = useResponsive('down', 'md', 'xl');
  const isSmall = useResponsive('down', 'sm', 'xl');
  const location = useLocation();

  const { token } = useAuth();
  const { showNotification } = useNotificationService();
  const [openFlagModal, setOpenFlagModal] = useState(false);

  const [timesheet_info, setTimesheet_info] = useState<TimesheetDetailsProps>(
    TimesheetDetailsPropsDummyData
  );

  useEffect(() => {
    const timesheetId = getUrlPathId(location?.pathname);
    const fields = { timesheetId, token };
    mutation.mutate(fields);
  }, []);

  const mutation = useMutation({
    mutationFn: (fields: { token: string; timesheetId: string }) =>
      apiGetTimesheetById(fields),
    onSuccess: (data) => {
      if (data?.status === 'error') {
        if ('msg' in data) {
          showNotification(data?.msg ?? '', 'error');
          return;
        }
        return;
      }
      if ('data' in data) {
        if (Array.isArray(data?.data?.data)) {
          setTimesheet_info(data.data.data[0]);
        } else {
          setTimesheet_info(data.data.data);
        }
      }
    },
    onError: (error) => {
      console.error('Fetch process failed', error);
      showNotification('Fetch process failed', 'error');
    },
  });

  const handleFlagTimesheet = () => {
    setOpenFlagModal(!openFlagModal);
  };

  return (
    <>
      <FlaggingModal
        open={openFlagModal}
        modalHandler={handleFlagTimesheet}
        selectedEmployeeId={timesheet_info?._id}
      />

      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginRight: '1rem',
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={'row'} alignItems={'center'} sx={{ gap: '10px' }}>
            <BackButton />
            <Typography
              variant={'subtitle1'}
              sx={{
                fontWeight: 500,
                fontFamily: 'Lexend',
                color: '#2F66F4',
              }}
            >
              Timesheet
            </Typography>
            {!isSmall && (
              <InputCustom
                type="text"
                placeholder="Search timesheet..."
                value=""
                onchange={() => {}}
                styles={{
                  width: isMedium ? 200 : 400,
                }}
              />
            )}
          </Stack>
          {!isSmall && (
            <Stack direction={'row'} sx={{ gap: 3 }}>
              <Button
                onClick={handleFlagTimesheet}
                sx={{
                  border: `1px solid ${theme.palette.primary.main}`,
                  padding: '4px 10px',
                  height: isMedium ? '35px' : '40px',
                  fontWeight: 700,
                  width: isMedium ? '60px' : '70px',
                  borderRadius: '12px',
                  fontSize: '13px',
                  fontFamily: 'DM Sans',
                }}
              >
                Flag
              </Button>
              {/* <Button
                sx={{
                  border: `1px solid ${theme.palette.primary.main}`,
                  padding: "4px 12px",
                  height: isMedium ? "35px" : "40px",
                  fontWeight: 700,
                  width: isMedium ? "70px" : "85px",
                  borderRadius: "12px",
                  fontSize: "13px",
                  fontFamily: "DM Sans",
                }}
              >
                Export
              </Button> */}
            </Stack>
          )}
        </Box>
      </Header>

      <TimesheetDetailsContent
        timesheetInfo={timesheet_info}
        loading={mutation.isPending}
      />
    </>
  );
};

export default TimesheetDetails;
